import AddIcon from '@mui/icons-material/Add';
import { Box, IconButton } from '@mui/material';
import { FC, memo } from 'react';

type ToolBarActionsProps = {
    handleAddRow: () => void;
    renderAddButton: boolean;
};

const ToolBarActions: FC<ToolBarActionsProps> = ({ handleAddRow, renderAddButton }) => {
    return (
        <Box display="flex" justifyContent="flex-end" alignItems="center" width="100%">
            {renderAddButton && (
                <IconButton onClick={handleAddRow} data-testid="add-action">
                    <AddIcon />
                </IconButton>
            )}
        </Box>
    );
};

export default memo(ToolBarActions);
